export default function ProfilingInputCN({ value, onChange, onSubmit, loading }) {
  return (
    <div className="reviewInput">
      <p className="inputTitle">新患者初始问诊数据:</p>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit?.();
        }}
      >
        <textarea
          name="textarea"
          rows="10"
          placeholder="例如：30岁女性，上班族。因经常加班和压力，一年内体重增加8kg。尤其是晚餐后很难抗拒宵夜（炒年糕、方便面）。经常不吃早餐，中午吃得很匆忙。晚上难以入睡，早晨醒来全身无力。最终目标是为备孕进行健康的体重管理。"
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={loading}
        />
        <button type="submit" className="submitbtn" disabled={loading}>
          {loading ? "创建中..." : "生成 AI 初诊患者画像"}
        </button>
      </form>
    </div>
  );
}
